export function* first(stream) {
    let subscription = yield* stream.subscribe();
    let result = yield* subscription.next();
    if (!result.done) {
        return result.value;
    }
}
//# sourceMappingURL=first.js.map